var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    clipPath: "url(#clip0_219_1017)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.9577 47.9271C97.2677 48.4131 94.4967 48.6667 91.6667 48.6667C66.0773 48.6667 45.3333 27.9227 45.3333 2.33352C45.3333 1.62205 45.3493 0.914328 45.381 0.210693C19.9321 2.54168 0 23.9432 0 50.0001C0 77.6144 22.3858 100 50 100C77.6143 100 100 77.6144 100 50.0001C100 49.3057 99.986 48.6147 99.9577 47.9271Z",
    fill: "#4c2e61"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_219_1017"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.e9dfb57c76c4adfd2c0c084b5ad5ba00.svg";
export { ForwardRef as ReactComponent };